<template>
  <div>
    <navigation-bar>
      <span slot="content">我的二维码</span>
    </navigation-bar>
    <div class="center">
      <br>
      <img class="code-img" v-if="user.barCodeURL" alt="加载中" v-bind:src="user.barCodeURL">
      <br>
      <span v-if="user.userId">{{user.userId + 131905000911}}</span>
      <br>
      <img class="code-img" v-if="user.qrURL" alt="加载中" v-bind:src="user.qrURL">
    </div>
    <div class="weui-footer">
      <p class="weui-footer__text">请出示给导游或商家</p>
    </div>
  </div>
</template>
<style lang="stylus">
  .code-img
    width:300px
</style>
<script>
  import NavigationBar from '../components/NavigationBar.vue'
  export default{
    computed: {
      user () {
        return this.$store.getters.getUserInfo
      }
    },

    components: {
      NavigationBar
    }
  }
</script>



// WEBPACK FOOTER //
// Card.vue?5329d598